import React, { useState, useRef } from 'react';
import styles from './Hiring.module.css';
import { textdb, storage } from '../../../firebase'; // Ensure path is correct
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL
} from "firebase/storage";
import { v4 as uuidv4 } from 'uuid'; // For unique file names: npm install uuid

// Inline SVG Components (remain unchanged)
const PencilIcon = ({ className }) => (
  <svg className={className} width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 9.1799 17.33 7.9199 16.95L3.7699 15.79C3.0499 15.57 2.4299 14.95 2.2099 14.23L1.0499 10.08C0.669901 8.82005 1.1099 7.21005 2.0599 6.26005L11.5999 -3.20005e-05C13.7899 -0.000053485 15.5999 1.81 15.5999 4.00005C15.5999 4.97005 15.2099 5.84005 14.6299 6.47005L13.4499 7.65005C13.1799 7.92005 13.1799 8.37005 13.4499 8.64005L19.3499 14.54C19.6199 14.81 20.0699 14.81 20.3399 14.54L21.5199 13.36C22.1599 12.78 23.0199 12.39 23.9899 12.39V4.00005C23.9899 1.80005 22.1899 -3.20005e-05 19.9999 -3.20005e-05L11.5999 -3.20005e-05" stroke="#52d8c5" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.0599 6.26005L11.5999 15.8C11.7199 15.92 11.8099 16.07 11.8599 16.24L12.4499 18.15C12.5699 18.55 12.3299 18.97 11.9199 19.09L10.0099 19.68C9.8399 19.73 9.6899 19.64 9.5699 19.52L0.0199014 10.0001C0.0099014 9.99005 -0.0000986391 9.97005 -0.0000986391 9.96005C-0.0000986391 8.15005 1.8099 6.34005 3.9999 6.34005C4.9699 6.34005 5.8399 6.73005 6.4699 7.31005L7.6499 8.49005C7.9199 8.76005 8.3699 8.76005 8.6399 8.49005L14.5399 2.59005C14.8099 2.32005 14.8099 1.87005 14.5399 1.60005L13.3599 0.420053C12.7799 -0.159947 11.9199 -0.549947 10.9499 -0.549947H4.00005C1.80005 -0.549947 -8.10538e-05 -0.000053485 -8.10538e-05 -0.000053485" stroke="#52d8c5" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
     <path d="M18.85 8.1499L19.35 8.6499C19.62 8.9199 20.07 8.9199 20.34 8.6499L21.52 7.4699C22.16 6.8899 23.02 6.4999 23.99 6.4999V4.0099C23.99 1.8199 22.19 1.0062e-05 20 1.0062e-05L11.6 1.0062e-05C13.79 -5.3485e-05 15.6 1.81005 15.6 4.00005C15.6 4.97005 15.21 5.84005 14.63 6.47005L13.45 7.65005C13.18 7.92005 13.18 8.37005 13.45 8.64005L14.06 9.25005" stroke="#52d8c5" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CameraIcon = ({ className }) => (
    <svg className={className} width="55" height="55" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.01 10.5C10.39 10.5 11.51 9.38 11.51 8C11.51 6.62 10.39 5.5 9.01 5.5C7.63 5.5 6.51 6.62 6.51 8C6.51 9.38 7.63 10.5 9.01 10.5Z" stroke="#52d8c5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13 18H5C2.79 18 1 16.21 1 14V10C1 7.79 2.79 6 5 6H13C15.21 6 17 7.79 17 10V14C17 16.21 15.21 18 13 18Z" stroke="#52d8c5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17 8.5H16.5" stroke="#52d8c5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13 6L15 2H21L19 6H13Z" stroke="#52d8c5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);


const Hiring = () => {
  const jobs = [
    { id: 1, title: "Sr. Graphic Designer", experience: "3 to 4 Years Experience", icon: 'pencil' },
    { id: 2, title: "Sr. Social Media Manager", experience: "3 to 4 Years Experience", icon: 'camera' },
    { id: 3, title: "Sr. Content Writer", experience: "3 to 4 Years Experience", icon: 'pencil' },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJobTitle, setSelectedJobTitle] = useState('');
  const [formData, setFormData] = useState({
    fullName: '',
    whatsappNumber: '',
    email: '',
    aboutYourself: '',
  });
  const [resumeFile, setResumeFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(''); // 'success', 'error', ''
  const [uploadProgress, setUploadProgress] = useState(0);
  const fileInputRef = useRef(null);


  const handleOpenModal = (jobTitle) => {
    setSelectedJobTitle(jobTitle);
    setIsModalOpen(true);
    setSubmitStatus('');
    setFormData({ fullName: '', whatsappNumber: '', email: '', aboutYourself: '' });
    setResumeFile(null);
    setFileName('');
    setUploadProgress(0);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset file input
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedJobTitle('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        alert("Please upload a PDF file only.");
        e.target.value = null; // Reset file input
        setResumeFile(null);
        setFileName('');
        return;
      }
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        alert(`File is too large. Maximum size is 5MB. Your file is ${(file.size / (1024*1024)).toFixed(2)}MB.`);
        e.target.value = null;
        setResumeFile(null);
        setFileName('');
        return;
      }
      setResumeFile(file);
      setFileName(file.name);
    } else {
      setResumeFile(null);
      setFileName('');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!formData.fullName || !formData.whatsappNumber || !formData.email || !formData.aboutYourself) {
      alert("Please fill in all text fields.");
      return;
    }
    if (!resumeFile) {
      alert("Please upload your resume.");
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('');
    setUploadProgress(0);

    try {
      let resumeURL = '';
      // Upload file to Firebase Storage
      const uniqueFileName = `${uuidv4()}-${resumeFile.name}`;
      const fileRef = storageRef(storage, `resumes/${uniqueFileName}`);
      const uploadTask = uploadBytesResumable(fileRef, resumeFile);

      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(Math.round(progress));
        },
        (error) => {
          console.error("Error uploading resume: ", error);
          setSubmitStatus('error');
          alert("Failed to upload resume. Please try again. Error: " + error.message);
          setIsSubmitting(false);
          setUploadProgress(0);
        },
        async () => {
          // Handle successful uploads on complete
          try {
            resumeURL = await getDownloadURL(uploadTask.snapshot.ref);
            // Add application to Firestore
            await addDoc(collection(textdb, "jobApplications"), {
              jobTitle: selectedJobTitle,
              ...formData,
              resumeURL: resumeURL,
              resumeFileName: resumeFile.name,
              appliedAt: serverTimestamp(),
            });
            setSubmitStatus('success');
            // alert("Application submitted successfully!"); // Using message in modal
            setTimeout(() => { // Give time for success message
                handleCloseModal();
            }, 2000);
          } catch (dbError) {
            console.error("Error submitting application to Firestore: ", dbError);
            setSubmitStatus('error');
            // alert("Failed to submit application data. Please try again."); // Using message
          } finally {
            setIsSubmitting(false);
          }
        }
      );
    } catch (error) { // Catch errors from initial setup before uploadTask
      console.error("Error preparing for submission: ", error);
      setSubmitStatus('error');
      alert("An unexpected error occurred. Please try again.");
      setIsSubmitting(false);
      setUploadProgress(0);
    }
  };


  return (
    <>
      <div className={styles.hiringContainer}>
        <div className={styles.titleSection}>
          <h2 className={styles.hashtag}>#उड़ान</h2>
          <h1 className={styles.mainTitle}>The Buzz Dream</h1>
          <p className={styles.subtitle}>
            Think you got what it takes to get buzzing with us? Apply Now!
          </p>
        </div>

        <div className={styles.jobsGrid}>
          {jobs.map((job) => (
            <div key={job.id} className={styles.jobCard}>
              <h3>{job.title}</h3>
              <p>{job.experience}</p>
              <button
                className={styles.applyButton}
                onClick={() => handleOpenModal(job.title)}
              >
                Apply Now
              </button>
              {job.icon === 'pencil' && <PencilIcon className={styles.cardIconPencil} />}
              {job.icon === 'camera' && <CameraIcon className={styles.cardIconCamera} />}
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <button className={styles.closeButton} onClick={handleCloseModal} disabled={isSubmitting}>
              ×
            </button>
            <h2>Apply for {selectedJobTitle}</h2>
            <form onSubmit={handleFormSubmit} className={styles.applicationForm}>
              <div className={styles.formGroup}>
                <label htmlFor="fullName">Full Name</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="whatsappNumber">WhatsApp Number</label>
                <input
                  type="tel"
                  id="whatsappNumber"
                  name="whatsappNumber"
                  value={formData.whatsappNumber}
                  onChange={handleInputChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="email">Email ID</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="aboutYourself">Tell us about yourself</label>
                <textarea
                  id="aboutYourself"
                  name="aboutYourself"
                  value={formData.aboutYourself}
                  onChange={handleInputChange}
                  rows="3"
                  required
                  disabled={isSubmitting}
                ></textarea>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="resume" className={styles.fileInputLabel}>
                  Upload Your Resume (PDF only, max 5MB)
                </label>
                <input
                  type="file"
                  id="resume"
                  name="resume"
                  accept=".pdf"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  className={styles.fileInput}
                  required
                  disabled={isSubmitting}
                />
                {fileName && <span className={styles.fileNameDisplay}>{fileName}</span>}
              </div>

              {isSubmitting && uploadProgress > 0 && (
                <div className={styles.progressBarContainer}>
                  <div
                    className={styles.progressBar}
                    style={{ width: `${uploadProgress}%` }}
                  >
                    {uploadProgress}%
                  </div>
                </div>
              )}

              <button type="submit" className={styles.submitApplicationButton} disabled={isSubmitting}>
                {isSubmitting ? (uploadProgress > 0 ? `Uploading: ${uploadProgress}%` : 'Submitting...') : 'Submit Application'}
              </button>
              {submitStatus === 'success' && <p className={styles.successMessage}>Application submitted successfully! We'll be in touch.</p>}
              {submitStatus === 'error' && <p className={styles.errorMessage}>Submission failed. Please check your details and file, then try again.</p>}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Hiring;